class StatBoxes {
	constructor() {
		this.statBoxes = document.querySelectorAll('.stat-box');

		this.statBoxes.forEach((statBox) => {
			statBox.addEventListener('in-view:in', () => {
				this.animate(statBox);
			});
		});
	}

	animate(element) {
		if (!element.classList.contains('active')) {
			element.classList.add('active');
			const numberElement = element.querySelector('.stat-box__number');
			const number = +numberElement.getAttribute('aria-label');

			requestAnimationFrame(() => this.ticker(0, number, numberElement));
		}
	}

	ticker(tick, max, element) {
		if (tick >= 50) {
			return;
		}

		tick++;
		const factor = max / 50;
		const newNumber = Math.floor(tick * factor);
		element.innerHTML = newNumber;
		setTimeout(() => {
			requestAnimationFrame(() => this.ticker(tick, max, element));
		}, 40);
	}
}

new StatBoxes();
